import { useLayoutEffect } from 'react';
import { isCapitalUI } from 'react-common/theme';
/** Existing service tables share their live, configuration-dependent headings with mobile cells. */
export function useCapitalCartTableLabels(root, services) {
    useLayoutEffect(() => {
        if (!isCapitalUI || !root.current)
            return;
        root.current.querySelectorAll('table.order-table').forEach(table => {
            const group = table.closest('.capital-cart-standalone');
            const headings = table.querySelectorAll('thead th').length
                ? table.querySelectorAll('thead th')
                : group === null || group === void 0 ? void 0 : group.querySelectorAll('table.order-table thead th');
            if (!(headings === null || headings === void 0 ? void 0 : headings.length))
                return;
            const labels = Array.from(headings).map(heading => { var _a; return ((_a = heading.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || ''; });
            table.querySelectorAll('tr.order-info').forEach(row => {
                let column = 0;
                Array.from(row.cells).forEach(cell => {
                    if (!cell.hasAttribute('data-label'))
                        cell.dataset.label = labels[column] || '';
                    column += cell.colSpan;
                });
            });
        });
    }, [root, services]);
}
